var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFF4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.99L27.53 27H12.47L20 13.99ZM20 10L9 29H31L20 10ZM21 24H19V26H21V24ZM21 18H19V22H21V18Z",
    fill: "#D33C56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredIcon);
export default __webpack_public_path__ + "static/media/expired-icon.99399f420a8b80c77a089578528ba2bd.svg";
export { ForwardRef as ReactComponent };